<div *ngIf="subTotal" class="checkout-container max-w-6xl mx-auto p-6">
  <!-- Page Title -->
  <h2 class="text-3xl font-serif mb-6" style="color: var(--lt-color-text-dark);">Checkout</h2>

  <div class="flex flex-col lg:flex-row gap-6">
    <!-- Main Checkout Area -->
    <div class="flex-1">
      <!-- Step Navigation -->
      <div class="checkout-steps flex flex-col sm:flex-row border-b mb-6" style="border-color: var(--lt-color-border-default);">
        <button *ngFor="let step of steps; let i = index"
                class="flex-1 py-4 px-6 font-medium text-center transition-colors duration-300 relative"
                [ngClass]="{'bg-gold text-white': i === activeStep, 'text-gray-600 hover:bg-gray-200': i !== activeStep}"
                (click)="setActiveStep(i)"
                [disabled]="i > activeStep">
       <!--   <span class="step-number absolute left-4 top-1/2 transform -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center bg-black text-white text-sm font-semibold" [ngClass]="{'bg-gold': i <= activeStep}">
            {{ i + 1 }}
          </span>-->
          <span class="step-label">{{ step }}</span>
        </button>
      </div>


      <div [ngClass]="{'hidden': activeStep !== 0}">
        <!-- Address Step -->
        <h3 class="text-xl font-medium mb-4" style="color: var(--lt-color-text-default);">Shipping Address</h3>
        <form [formGroup]="addressForm" class="space-y-4">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--lt-color-text-default);">Nom</label>
              <input formControlName="name" type="text" class="w-full p-3 border rounded-lg focus:ring-gold focus:border-gold" style="border-color: var(--lt-color-border-default);"  [ngClass]="{'border-red-500': addressForm.get('name')?.invalid && addressForm.get('name')?.touched}">
              <p *ngIf="addressForm.get('name')?.invalid && addressForm.get('name')?.touched" class="text-red-500 text-sm">Name is required</p>
            </div>
            <div>
              <label for="phone" class="block text-sm font-medium mb-1" style="color: var(--lt-color-text-default);">Numéro de téléphone</label>
              <input formControlName="phone" type="tel" id="phone" inputmode="tel" pattern="[0-9\s\-\+()]*" class="w-full p-3 border rounded-lg focus:ring-gold focus:border-gold" style="border-color: var(--lt-color-border-default);"  [ngClass]="{'border-red-500': addressForm.get('phone')?.invalid && addressForm.get('phone')?.touched}">
              <p *ngIf="addressForm.get('phone')?.invalid && addressForm.get('phone')?.touched" class="text-red-500 text-sm">Valid phone number is required</p>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--lt-color-text-default);">Address</label>
            <input formControlName="address" type="text" class="w-full p-3 border rounded-lg focus:ring-gold focus:border-gold" style="border-color: var(--lt-color-border-default);"  [ngClass]="{'border-red-500': addressForm.get('address')?.invalid && addressForm.get('address')?.touched}">
            <p *ngIf="addressForm.get('address')?.invalid && addressForm.get('address')?.touched" class="text-red-500 text-sm">Address is required</p>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--lt-color-text-default);">City</label>
              <input formControlName="city" type="text" class="w-full p-3 border rounded-lg focus:ring-gold focus:border-gold" style="border-color: var(--lt-color-border-default);"  [ngClass]="{'border-red-500': addressForm.get('city')?.invalid && addressForm.get('city')?.touched}">
              <p *ngIf="addressForm.get('city')?.invalid && addressForm.get('city')?.touched" class="text-red-500 text-sm">City is required</p>
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--lt-color-text-default);">Postal Code</label>
              <input formControlName="postalCode" type="text" class="w-full p-3 border rounded-lg focus:ring-gold focus:border-gold" style="border-color: var(--lt-color-border-default);"  [ngClass]="{'border-red-500': addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched}">
              <p *ngIf="addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched" class="text-red-500 text-sm">Postal code is required</p>
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--lt-color-text-default);">Country</label>
              <input formControlName="country" type="text" class="w-full p-3 border rounded-lg focus:ring-gold focus:border-gold" style="border-color: var(--lt-color-border-default);"  [ngClass]="{'border-red-500': addressForm.get('country')?.invalid && addressForm.get('country')?.touched}">
              <p *ngIf="addressForm.get('country')?.invalid && addressForm.get('country')?.touched" class="text-red-500 text-sm">Country is required</p>
            </div>
          </div>
          <div class="flex justify-between mt-4">
            <button (click)="placeOrder()" class="bg-gold text-white px-6 py-3 rounded-full font-semibold">Place Order</button>
          </div>
        </form>
      </div>
    </div>

      <!-- Sidebar (Order Summary) -->
    <div class="w-full lg:w-1/3">
      <div class="p-6 border rounded-lg sticky top-6" style="border-color: var(--lt-color-border-default); background-color: var(--lt-color-background-light);">
        <h3 class="text-xl font-medium mb-4" style="color: var(--lt-color-text-default);">Order Summary</h3>
        <div  class="space-y-3">
          <div class="flex justify-between text-sm" style="color: var(--lt-color-text-light);">
            <span>Subtotal</span>
            <span>{{ subTotal | currency:'MAD':'symbol':'1.0-0' }}</span>
          </div>
          <div class="flex justify-between text-sm" style="color: var(--lt-color-text-light);">
            <span>Shipping</span>
            <span>{{ 40 | currency:'MAD':'symbol':'1.0-0' }}</span>
          </div>
          <div class="flex justify-between text-lg font-semibold border-t pt-3" style="border-color: var(--lt-color-border-default); color: var(--lt-color-text-dark);">
            <span>Total</span>
            <span>{{ subTotal + 40 | currency:'MAD':'symbol':'1.0-0' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="subTotal === 0" class="empty-cart-message text-center py-10">
  <h2 class="text-2xl font-semibold" style="color: var(--lt-color-text-dark);">Your cart is empty</h2>
  <p class="text-sm mt-2" style="color: var(--lt-color-text-light);">Add items to your cart to proceed to checkout.</p>
</div>
